export function converDataFromBytes(sizeInBytes: number) {
    var unitsValue = ['B', 'KB', 'MB', 'GB', 'TB'];
    if (sizeInBytes === 0) {
        sizeInBytes = 0;
        return sizeInBytes + unitsValue[0];
    } else {
        var i: any = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
        var decs: any = unitsValue[i] === 'GB' ? 1 : 0;
        let size: any = sizeInBytes / Math.pow(1024, i);
        let sizeInBytes1: any = size.toFixed(decs) * 1;
        return sizeInBytes1 + ' ' + unitsValue[i];
    }
}

export function bytesToSize(bytes: any) {
    var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0 || !bytes) return '0 B';
    let i: any = Math.floor(Math.log(bytes) / Math.log(1024));
    if (i == 0) return bytes + ' ' + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
}

export function getHigherNumberMBorGBFromBytes(bytes: number): any {
    if (bytes < 1024 || bytes < 1024 * 1024 || bytes < 1024 * 1024 * 1024) {
      return Math.ceil(bytes / (1024 * 1024)).toFixed(2) + " MB";
    } else {
      return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
    }
}